// src/composables/useWeather.js

export async function getCurrentWeather() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error('브라우저에서 위치 정보를 지원하지 않습니다.'))
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const lat = position.coords.latitude
          const lon = position.coords.longitude
          const apiKey = import.meta.env.VITE_OPENWEATHER_API_KEY

          const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=metric&lang=kr`
          const res = await fetch(url)
          const data = await res.json()

          resolve({
            temp: data.main.temp,
            condition: data.weather[0].main, // Clear, Rain, Clouds 등
            description: data.weather[0].description, // 맑음, 흐림 등
          })
        } catch (err) {
          reject(err)
        }
      },
      (error) => {
        reject(new Error('위치 정보를 가져올 수 없습니다.'))
      },
    )
  })
}
